import { render, staticRenderFns } from "./SeverityDropdowns.vue?vue&type=template&id=644060ae"
import script from "./SeverityDropdowns.vue?vue&type=script&lang=js"
export * from "./SeverityDropdowns.vue?vue&type=script&lang=js"
import style0 from "./SeverityDropdowns.vue?vue&type=style&index=0&id=644060ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports